module.exports = require("@szgc/plt-core-v2");